import service from '@/api/commission';
import {loading, handleError} from '@/state/generators/helpers';
import {alert} from "../generators/helpers";

export const state = {
    service: service('commissions')
}

export const getters = {}

export const mutations = {}

export const actions = {
    save: function ({commit, state}, payload) {
        loading(commit)

        const data = payload.reduce((total = [], interaction) => {
            interaction.users.forEach(u => {
                total.push(u.commission);
            });
            return total;
        }, []);

        return state.service.saveMany(data).then((response) => {
            alert(commit, this.$t('request.save_is_successful'))
            loading(commit, false)
            return response;
        }).catch((e) => {
            handleError(e, commit);
        });
    },
}
